// extracted by mini-css-extract-plugin
module.exports = {"backButton":"EmergencyAgsn_backButton__VE1kz","tableView":"EmergencyAgsn_tableView__1pDLj","container":"EmergencyAgsn_container__9jyk-"};